import { render, staticRenderFns } from "./AllergyDetail.vue?vue&type=template&id=19e15899"
import script from "./AllergyDetail.vue?vue&type=script&lang=js"
export * from "./AllergyDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports